import { render } from "./EditMember.vue?vue&type=template&id=4c6ccb6c"
import script from "./EditMember.vue?vue&type=script&lang=js"
export * from "./EditMember.vue?vue&type=script&lang=js"
script.render = render

export default script